<template>
  <div class="audit-status-cell">
    <template v-if="status == CONFIRM_STATUS.NOT_AUDIT">
      <div class="audit-status__icon">
        <i class="el-icon-warning" style="color: orange"></i>
      </div>
      <div class="audit-status__label">Chưa kiểm toán</div>
    </template>
    <template v-else-if="status == CONFIRM_STATUS.AUDITED">
      <div class="audit-status__icon">
        <i class="el-icon-question" style="color: blue" />
      </div>
      <div class="audit-status__label">Chờ xác nhận</div>
    </template>
    <template v-else-if="status == CONFIRM_STATUS.CONFIRMED">
      <div class="audit-status__icon">
        <i class="el-icon-success" style="color: green"></i>
      </div>
      <div class="audit-status__label">Đã xác nhận</div>
    </template>
    <template v-else-if="status == CONFIRM_STATUS.RESPONSE_WRONG">
      <div class="audit-status__icon">
        <i class="el-icon-error" style="color: red"></i>
      </div>
      <div class="audit-status__label">Phản hồi sai</div>
    </template>
  </div>
</template>

<script>
import { CONFIRM_STATUS } from '../constant'

export default {
  data() {
    return {
      status: null
    }
  },
  computed: {
    CONFIRM_STATUS() {
      return CONFIRM_STATUS
    }
  },
  created() {
    this.status = this.params.data.status
  }
}
</script>

<style lang="scss" scoped>
.audit-status-cell {
  display: flex;
  // justify-content: center;
  align-items: center;
  gap: 10px;

  .audit-status {
    &__label {
    }

    &__icon {
      display: flex;
      position: relative;
      top: -1px;
      i {
        font-size: 20px;
      }
    }
  }
}
</style>
